// Copyright (c) StrangeBee 2023

import { ICONS } from '@Constants/iconsApp';
import { THInputNumber } from '@Molecules/Inputs/THInputNumber/THInputNumber';
import { THForm } from '@Molecules/THForm/THForm';
import { ValidateStatus } from 'antd/lib/form/FormItem';
import { ReactElement, useState } from 'react';
import { classList } from '@Helpers/className';

import './NumericInput.scss';

interface NumericInputProps {
    onFinish: (...args: any[]) => any;
    placeholder?: string;
}

export const NumericInput = ({ onFinish, placeholder = 'Input number' }: NumericInputProps): ReactElement => {
    const [value, setValue] = useState<number | null>(null);
    const [status, setStatus] = useState<ValidateStatus>();
    const [focused, setFocused] = useState<boolean>(false);

    const resetForm = (): void => {
        setStatus('');
        setValue(null);
    };

    const onFinishHandler = (): void => {
        if (status === 'success') {
            onFinish(value);
        }
        resetForm();
    };

    const onChange = (value: string | number | null): void => {
        const valueIsNumber = /^\d+$/.test(value + '');

        if (value === '') {
            resetForm();
            return;
        }

        if (valueIsNumber) {
            setValue(parseInt(value + ''));
            setStatus('success');
        } else {
            setStatus('error');
        }
    };

    return (
        <THForm editable onFinish={onFinishHandler} className="numeric-input__form">
            <THForm.Item className={classList('numeric-item', { 'numeric-item-focused': focused })}>
                <THInputNumber
                    noArrows
                    borderless
                    className="numeric-input"
                    onChange={(value) => onChange(value)}
                    placeholder={placeholder}
                    value={value ?? undefined}
                    min={1}
                    maxLength={25}
                    addonAfter={<ICONS.SearchIcon className="arrow" />}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                />
            </THForm.Item>
        </THForm>
    );
};
